import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NotificationService } from '@app/services/notification.service';

@Component({
  selector: 'app-notification',
  template: `<section class="stack" aria-live="polite" aria-label="Meldingen">
    @for (item of service.notifications(); track item.id) {
      <article [class]="item.type">
        <span>{{ item.message }}</span
        ><button type="button" (click)="service.remove(item.id)" aria-label="Melding sluiten">
          ×
        </button>
      </article>
    }
  </section>`,
  styles: `
    .stack {
      position: fixed;
      z-index: 2000;
      right: 1rem;
      top: 1rem;
      display: grid;
      gap: 0.6rem;
      width: min(24rem, calc(100vw - 2rem));
    }
    article {
      display: flex;
      justify-content: space-between;
      gap: 1rem;
      padding: 0.85rem 1rem;
      border: 1px solid var(--safegpt-border);
      border-left: 4px solid var(--safegpt-blue-text);
      border-radius: 8px;
      background: var(--safegpt-surface-elevated);
      box-shadow: 0 10px 30px var(--safegpt-shadow);
      color: var(--safegpt-text);
    }
    article.success {
      border-left-color: var(--safegpt-success-text);
    }
    article.error {
      border-left-color: var(--safegpt-danger-text);
    }
    article.warning {
      border-left-color: var(--safegpt-warning-text);
    }
    button {
      border: 0;
      background: transparent;
      color: inherit;
      font-size: 1.2rem;
      cursor: pointer;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationComponent {
  protected readonly service = inject(NotificationService);
}
